/* global BackboneEx */
import React from 'react';
import ReactDOM from 'react-dom';
import { Reconnect } from 'federation/Reconnect';

function getModuleUrl(moduleName) {
  return Wahanda.Url.getFullUrl(moduleName).split('#')[0];
}

App.Views.PhoneSupport = BackboneEx.View.Main.extend({
  initialize() {},

  render() {
    App.headerView.setModule('phone-support');
    const node = this.$('#phone-support-section').get(0);
    if (node) {
      ReactDOM.render(
        <Reconnect
          name="PremiumPhoneSupportPage"
          props={{
            basePath: getModuleUrl('phone-support'),
            dashboardUrl: getModuleUrl('dashboard'),
          }}
        />,
        node,
      );
    }
  },
});
